import React, { useState } from 'react';
import { db, hasFirebaseConfig } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import styles from './Signup.module.css';

const jokes = [
  "i write when something's worth saying. could be weekly. could be never."
];

const SUBMIT_TIMEOUT_MS = 12000;

const withTimeout = (promise, timeoutMs) =>
  Promise.race([
    promise,
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error('submit-timeout')), timeoutMs);
    }),
  ]);

const Signup = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [twitter, setTwitter] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [randomJoke] = useState(jokes[Math.floor(Math.random() * jokes.length)]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!hasFirebaseConfig) {
      setError('signup is not configured yet. add Firebase env vars and redeploy.');
      return;
    }

    setLoading(true);

    try {
      if (!name.trim()) {
        setError('i need to know your name man (mandatory)');
        return;
      }

      if (!email.trim()) {
        setError('email required (obviously)');
        return;
      }

      if (!twitter.trim()) {
        setError('twitter handle is mandatory (for vibes checking)');
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setError("that doesn't look like an email...");
        return;
      }

      await withTimeout(
        addDoc(collection(db, 'gmail-oomfs'), {
          name: name.trim(),
          email: email.toLowerCase(),
          twitter: twitter.startsWith('@') ? twitter : `@${twitter}`,
          timestamp: serverTimestamp(),
        }),
        SUBMIT_TIMEOUT_MS,
      );

      setSubmitted(true);
      setName('');
      setEmail('');
      setTwitter('');
      setTimeout(() => setSubmitted(false), 4000);
    } catch (err) {
      console.error('Error:', err);
      if (err && err.message === 'submit-timeout') {
        setError('taking too long to submit. check network/firestore rules and try again.');
      } else {
        setError('could not submit right now. check Firebase config/rules and try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.signupContainer}>
      <div className={styles.signupBox}>
        <div className={styles.header}>
          <h1>
            <span>wanna be basith k laddu?</span>
          </h1>
          <p className={styles.subtitle}>goomf = gmail-oomf. join the newsletter.</p>
        </div>

        {submitted ? (
          <div className={styles.successMessage}>
            <p>✓ you're in!</p>
            <p className={styles.successSub}>check your inbox (or spam, no judgment)</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
              <input
                type="text"
                placeholder="your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                disabled={loading}
                className={styles.input}
              />
            </div>

            <div className={styles.formGroup}>
              <input
                type="email"
                placeholder="email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                className={styles.input}
              />
            </div>

            <div className={styles.formGroup}>
              <input
                type="text"
                placeholder="twitter handle"
                value={twitter}
                onChange={(e) => setTwitter(e.target.value)}
                disabled={loading}
                className={styles.input}
              />
            </div>

            {error && <p className={styles.error}>{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className={styles.submitBtn}
            >
              {loading ? 'sending...' : 'sign me up'}
            </button>
          </form>
        )}

        <p className={styles.joke}>{randomJoke}</p>

        <div className={styles.socials}>
          <p className={styles.socialsTitle}>find me elsewhere:</p>
          <ul className={styles.socialsList}>
            <li><a href="mailto:basithladoo@gmail.com" target="_blank" rel="noopener noreferrer">email</a></li>
            <li><a href="https://instagram.com/basithladdu" target="_blank" rel="noopener noreferrer">instagram</a></li>
            <li><a href="https://twitter.com/basithladdu" target="_blank" rel="noopener noreferrer">twitter</a></li>
            <li><a href="https://youtube.com/@basithladdu" target="_blank" rel="noopener noreferrer">youtube</a></li>
            <li><a href="https://letterboxd.com/basithladoo/" target="_blank" rel="noopener noreferrer">letterboxd</a></li>
            <li><a href="https://open.spotify.com/user/31kc2rvppa2sk2v63yrggc2lp7s4?si=c0e8772f810b43a4" target="_blank" rel="noopener noreferrer">spotify</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Signup;